// app/modules/apps/call/report/servicelevelagent-list/core/_requests.ts
import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../../_metronic/helpers'
import {Data, QueryResponse, QueueResponse} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const GET_URL = `${API_URL}/call/recording/outbound`


function injectAgentFilter(query: string): string {
  try {
    const raw = localStorage.getItem('kt-auth-react-v')
    if (!raw) return query

    const parsed = JSON.parse(raw)
    const name = parsed.name || '' 
    const roles = parsed.roles || []
    
    const isAgentOnly = roles.includes('ROLE_AGENT')

    if (isAgentOnly && name) {
      const params = new URLSearchParams(query)
      
      params.set('filter_agent', name.toLowerCase()) 
      
      return params.toString().replace(/\+/g, '%20')
    }
  } catch (e) {
    console.error('Error injecting agent filter:', e)
  }
  return query
}

// --- GET DATA (PAGINASI / FILTER) ---
const getData = (query: string): Promise<QueryResponse> => {
  const secureQuery = injectAgentFilter(query)
  return axios.get(`${GET_URL}?${secureQuery}`).then((d: AxiosResponse<QueryResponse>) => d.data)
}

// --- EXPORT ALL ---
const getAllDataForExport = (query: string): Promise<AxiosResponse<QueryResponse>> => {
  const secureQuery = injectAgentFilter(query)
  return axios.get(`${GET_URL}?${secureQuery}&all=true`)
}

// --- GET QUEUES (REAL API, NO DUMMY) ---
// const getQueues = async () => {
//   return axios
//     .get(`${API_URL}/call/queue/query`)
//     .then((res) => res.data)
// }
const getAgent = async () => {
  return axios
    .get(`${API_URL}/roles/6/users`)
    .then((res) => {
      const data = res.data
      
      try {
        const raw = localStorage.getItem('kt-auth-react-v')
        if (raw) {
          const parsed = JSON.parse(raw)
          const name = parsed.name || ''
          const roles = parsed.roles || []
          
          const isAgentOnly = roles.includes('ROLE_AGENT')

          if (isAgentOnly && name && Array.isArray(data)) {
            return data.filter((agent: any) => agent.nama?.toLowerCase() === name.toLowerCase())
          }
        }
      } catch (e) {
        console.error('Error filtering agent list:', e)
      }

      return data
    })
}

const getAudio = async (uniqueId: string) => {
  return axios.get(`${API_URL}/call/recording/preview/${uniqueId}`, {
    responseType: 'blob',
    headers: {
      'Authorization': `Bearer ${getApiToken()}`
    }
  })
}

const downloadAudio = async (uniqueId: string) => {
  return axios.get(`${API_URL}/call/recording/download/${uniqueId}`, {
    responseType: 'blob',
    headers: {
      'Authorization': `Bearer ${getApiToken()}`
    }
  })
}

const getCampaign = async () => {
  return axios
    .get(`${API_URL}/call/campaign/list`)
    .then((res) => res)
}


// --- GET SUMMARY STATS (REAL API, NO DUMMY) ---
export type SummaryStats = {
  totalCalls: number
  answered: number
  abandoned: number
  slaAchieved: number
}

const getSummaryStats = (): Promise<AxiosResponse<SummaryStats>> => {
  return axios.get(`${GET_URL}/stats`)
}


function getApiToken() {
  try {
    const raw = localStorage.getItem('kt-auth-react-v')
    if (!raw) return ''
    const parsed = JSON.parse(raw)
    return parsed.api_token || ''
  } catch {
    return ''
  }
}

const getPhoneNumberDetail = async (id: string, page: number, limit: number) => {
  return axios.get(`${API_URL}/call/recording/detail/${id}`, {
    params: { page, limit }
  }).then((res) => res.data);
};

const updatePhoneNumberNotes = async (uniqueid: string, notesJsonString: string): Promise<any> => {
  return axios
    .post(`${API_URL}/call/recording/update-notes/${uniqueid}`, 
      { notes: notesJsonString }
    )
    .then((res) => res.data)
}


// --- EXPORTS ---
export {
  getData, 
  getAllDataForExport, 
  getSummaryStats, 
  getAgent, 
  getCampaign, 
  getAudio, 
  downloadAudio,
  getPhoneNumberDetail,
  updatePhoneNumberNotes
}